import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { forEach } from '@beef/utils';
import uuid from "../../utils/uuid";
import { NodeTreeProjection } from "./NodeTreeProjection";
/**
 * Convert prop from flexible array format to raw value
 */
export var NodeTree = /*#__PURE__*/function (_NodeTreeProjection) {
  _inherits(NodeTree, _NodeTreeProjection);
  var _super = _createSuper(NodeTree);
  function NodeTree(nodes, childUtils) {
    var _this;
    _classCallCheck(this, NodeTree);
    _this = _super.call(this, nodes);
    _this.nodes = nodes;
    _this.childUtils = childUtils;
    return _this;
  }
  _createClass(NodeTree, [{
    key: "generateNodeId",
    value: function generateNodeId() {
      return uuid();
    }
  }, {
    key: "attachNode",
    value: function attachNode(data) {
      data.nodeId = data.nodeId || this.generateNodeId();
      this.nodes[data.nodeId] = this.childUtils.create(data, {});
      return data.nodeId;
    }
  }, {
    key: "detachNode",
    value: function detachNode(_ref) {
      var nodeId = _ref.nodeId;
      delete this.nodes[nodeId];
    }
  }, {
    key: "accept",
    value: function accept(visitor) {
      forEach(this.nodes, function (node, nodeId) {
        return visitor.visit(node, {
          nodeId: nodeId
        });
      });
    }
  }, {
    key: "isEmpty",
    value: function isEmpty() {
      return Object.keys(this.nodes).length === 0;
    }
  }]);
  return NodeTree;
}(NodeTreeProjection);